import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  Icon,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQualitaSetPublish } from "../../../../effects/lotto/attributes/qualita";
import { QualitaPublishFormData } from "../../../../interfaces/lotto/attributes/forms";
import Transition from "../../../../lib/dialogTransition";
import { IPublishDialogProps } from "./interfaces";

const i18_PATH = "qualita.dialog.publishOnTheWeb.";

function PublishDialog({ qualita, isOpen, close }: IPublishDialogProps) {
  const { t } = useTranslation();

  const [formData, setFormData] = useState<QualitaPublishFormData>(null);

  const onClose = () => {
    setFormData(null);
    close();
  };

  const onSubmit = () => {
    setFormData({ isWebPublished: !qualita?.ext?.pubblicatoSuWeb });
  };
  useEffect(() => {
    setFormData(null);
  }, [isOpen, qualita]);

  useQualitaSetPublish(qualita.id, formData);

  return (
    <Dialog
      open={isOpen}
      onClose={close}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="md"
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar variant="dense">
          <Typography variant="h5" sx={{ flex: 1 }} display="block">
            {t(`${i18_PATH}Title`)}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <Icon className="fa-light fa-xmark" sx={{ overflow: "visible" }} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, overflowY: "auto" }}>
        {!qualita.ext?.pubblicatoSuWeb && (
          <Typography variant="h5" sx={{ flex: 1 }} display="block">
            {t(`${i18_PATH}PublishInfo`)}
          </Typography>
        )}
        {qualita.ext?.pubblicatoSuWeb && (
          <Typography variant="h5" sx={{ flex: 1 }} display="block">
            {t(`${i18_PATH}RemovePublicationInfo`)}
          </Typography>
        )}
      </Box>
      <DialogActions>
        <Button onClick={onSubmit} variant="contained" color="primary">
          {t(`${i18_PATH}Si`)}
        </Button>
        <Button onClick={onClose}> {t(`${i18_PATH}No`)}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PublishDialog;
